import React, { useEffect, useState } from "react";
import Header from "../components/dynamic/Header";
import ActionButton from "../components/dynamic/ActionButton";
import Badge from "../components/dynamic/Badge";
import LearnMoreLink from "../components/dynamic/LearnMoreLink";
import PlutoInfoModal from "../components/dynamic/PlutoInfoModal";
import { useAuthStore } from "../store/authStore";
import ShieldCheck from "/icons/shield-check.svg";
import LockClosed from "/icons/lock-closed.svg";

const StartView: React.FC = () => {
  const setHasStarted = useAuthStore((state) => state.setHasStarted);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (window.location.hostname === "localhost") {
      setHasStarted(true);
    }
  }, []);

  const handleStart = () => {
    setHasStarted(true);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="flex flex-col items-center h-full relative">
      <Header
        title="Link your account instantly"
        subheader=""
        align="left"
        className="!mt-0"
      />

      <div className="flex flex-col gap-3 mb-6 w-full">
        <div className="flex flex-col items-start gap-2">
          <div className="mt-1">
            <Badge
              text="You're in control"
              icon={
                <img
                  src={ShieldCheck}
                  alt="Shield check"
                  width={20}
                  height={20}
                />
              }
              className="!bg-white border border-black"
            />
          </div>
          <span className="text-sm text-text-secondary dark:text-text-secondary-dark">
            You're in control of the data that you choose to share.
          </span>
        </div>

        <div className="flex flex-col items-start gap-2">
          <div className="mt-1">
            <Badge
              text="Keep your data safe"
              icon={
                <img
                  src={LockClosed}
                  alt="Lock closed"
                  width={20}
                  height={20}
                />
              }
              className="!bg-white border border-black"
            />
          </div>
          <span className="text-sm text-text-secondary dark:text-text-secondary-dark">
            Pluto uses best in-class encryption to protect your data.
          </span>
        </div>
        {/* <div className="text-center mt-4">
          <LearnMoreLink text="Why do we use Pluto?" onClick={openModal} />
        </div> */}
      </div>

      <div className="w-full mt-auto mb-4">
        <ActionButton label="Get Started" onClick={handleStart} />
      </div>

      {isModalOpen && (
        <PlutoInfoModal isOpen={isModalOpen} onClose={closeModal} />
      )}
    </div>
  );
};

export default StartView;
